export default __webpack_public_path__ + "static/okta-944717e8c7427320166fac0110a99e32.png";